import { useMemo } from 'react';
import { baseTheme } from '../baseTheme';
import { entidadeTheme, createEntidadeTheme } from '../entidadeTheme';

const ENTIDADE_THEME_KEYS = [
  'primary',
  'primary_dark',
  'primary_soft',
  'primary_soft_border',
  'panel',
  'text',
  'text_muted',
  'link'
];

const HEX_COLOR_PATTERN = /^#(?:[0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i;

const isHexColor = pValue => typeof pValue === 'string' && HEX_COLOR_PATTERN.test(pValue.trim());

const normalizeEntidadeThemePayload = pThemeSource => {
  if (!pThemeSource || typeof pThemeSource !== 'object' || Array.isArray(pThemeSource)) {
    return null;
  }

  const xNormalized = {};

  for (const xKey of ENTIDADE_THEME_KEYS) {
    if (!isHexColor(pThemeSource[xKey])) {
      return null;
    }

    xNormalized[xKey] = pThemeSource[xKey].trim();
  }

  return xNormalized;
};

const buildRuntimeBaseFromEntidadeTheme = pEntidadeTheme => ({
  ...baseTheme,
  colors: {
    ...baseTheme.colors,
    primary: {
      ...baseTheme.colors.primary,
      lightness: pEntidadeTheme.primary_soft,
      light: pEntidadeTheme.primary_soft_border,
      main: pEntidadeTheme.primary,
      dark: pEntidadeTheme.primary_dark,
      darkness: pEntidadeTheme.primary_dark,
      contrastText: '#ffffff'
    },
    secondary: {
      ...baseTheme.colors.secondary,
      lightness: pEntidadeTheme.panel,
      light: pEntidadeTheme.primary_soft,
      main: pEntidadeTheme.primary_soft_border,
      dark: pEntidadeTheme.primary_soft_border,
      darkness: pEntidadeTheme.primary_dark,
      contrastText: pEntidadeTheme.text
    },
    info: {
      ...baseTheme.colors.info,
      highlight: pEntidadeTheme.link
    },
    text: {
      ...baseTheme.colors.text,
      primary: pEntidadeTheme.text,
      secondary: pEntidadeTheme.text_muted,
      disabled: pEntidadeTheme.text_muted,
      disabledInvert: pEntidadeTheme.text_muted,
      hint: pEntidadeTheme.text_muted
    },
    divider: {
      ...baseTheme.colors.divider,
      main: pEntidadeTheme.primary_soft_border
    },
    background: {
      ...baseTheme.colors.background,
      light: pEntidadeTheme.panel,
      main: pEntidadeTheme.panel,
      dark: pEntidadeTheme.primary_soft,
      contrastText: pEntidadeTheme.text,
      paper: pEntidadeTheme.panel,
      default: pEntidadeTheme.panel
    },
    background_theme_secondary: {
      ...baseTheme.colors.background_theme_secondary,
      light: pEntidadeTheme.panel,
      main: pEntidadeTheme.panel,
      dark: pEntidadeTheme.primary_soft,
      contrastText: pEntidadeTheme.text,
      paper: pEntidadeTheme.panel,
      default: pEntidadeTheme.panel
    },
    link: pEntidadeTheme.link
  }
});

export const useDynamicEntidadeTheme = pThemeSource => {
  console.log('pThemeSource', pThemeSource);
  const entidadeThemePayload = useMemo(
    () => normalizeEntidadeThemePayload(pThemeSource),
    [pThemeSource]
  );

  return useMemo(() => {
    if (!entidadeThemePayload) {
      return entidadeTheme;
    }

    return createEntidadeTheme(buildRuntimeBaseFromEntidadeTheme(entidadeThemePayload));
  }, [entidadeThemePayload]);
};

export default useDynamicEntidadeTheme;
